import React from 'react'
import pdf from '../../assets/icons/pdf.svg'
import doc from '../../assets/icons/file.svg'
import { Close } from '@material-ui/icons'
import { ListItemAvatar, Avatar } from '@material-ui/core'
interface Props {
  src?: string
  onClick: any
  remove?: any
  mediaType?: any
  diffClass?: boolean
}
export const UploadPreview = ({
  src,
  onClick,
  remove,
  mediaType,
  diffClass,
}: Props) => {
  return (
    <div className="preview-wrapper" style={{ position: 'relative' }}>
      {remove && (
        <ListItemAvatar
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            padding: 0,
            cursor: 'pointer',
            zIndex: 2,
          }}
        >
          <Avatar
            className={diffClass ? 'close-btn-alternate' : 'close-btn'}
            onClick={onClick}
            style={{ backgroundColor: '#f44336', width: 24, height: 24 }}
          >
            <Close fontSize="small" />
          </Avatar>
        </ListItemAvatar>
      )}

      <a href={src} target="_blank" rel="noreferrer">
        {mediaType ? (
          <>
            {mediaType.includes('image') ? (
              <img
                src={src}
                className={diffClass ? 'img-preview-alternate' : 'img-preview'}
                loading="lazy"
                alt="img"
              />
            ) : mediaType.includes('pdf') ? (
              <img src={pdf} className="img-preview" loading="lazy" alt="pdf" />
            ) : mediaType.includes('video') ? (
              <video className="vid_preview" controls>
                <source id="videoSource" src={src} />
              </video>
            ) : mediaType.includes('blob') || mediaType.includes('audio') ? (
              <audio id="audioSource" src={src} controls />
            ) : (
              <img
                src={doc}
                className="img-preview"
                loading="lazy"
                width="50"
                height="50"
                alt="doc"
              />
            )}
          </>
        ) : (
          <img src={src} className="img-preview" loading="lazy" alt="img" />
        )}
      </a>
    </div>
  )
}
